/**
 * Adapter: wraps legacy enhancedObjectivesManager singleton (Strangler Fig UC-23)
 */
import { enhancedObjectivesManager } from '../../../services/enhancedObjectivesManager';
import type { EnhancedObjectivesManager } from '../../../services/enhancedObjectivesManager';
import type { IEnhancedObjectivesEvaluator } from '../../domain/ports/IEnhancedObjectivesEvaluator';
import type {
  EnhancedObjective,
  ObjectiveContext,
  ObjectiveNotification,
} from '../../../types/enhancedObjectives';

export class EnhancedObjectivesAdapter implements IEnhancedObjectivesEvaluator {
  constructor(
    private readonly manager: EnhancedObjectivesManager = enhancedObjectivesManager,
  ) {}

  evaluate(context: ObjectiveContext): void {
    this.manager.evaluateObjectives(context);
  }

  addObjective(objective: EnhancedObjective): void {
    this.manager.addObjective(objective);
  }

  setNotificationCallback(
    callback: (notification: ObjectiveNotification) => void,
  ): void {
    this.manager.setNotificationCallback(callback);
  }
}